import { isIOS, isAndroid, isWeb } from './platform';
import * as iosShare from './ios/share';
import * as androidShare from './android/share';

/**
 * Cross-platform share utility
 * Automatically uses the correct implementation based on platform
 */
export async function share(options) {
  if (isIOS()) {
    return await iosShare.share(options);
  } else if (isAndroid()) {
    return await androidShare.share(options);
  } else if (isWeb()) {
    // Web fallback
    if (navigator.share) {
      const shareData = {};
      if (options.title) shareData.title = options.title;
      if (options.text) shareData.text = options.text;
      if (options.url) shareData.url = options.url;
      
      await navigator.share(shareData);
      return { presented: true };
    } else {
      throw new Error('Web Share API not available');
    }
  } else {
    throw new Error('Unsupported platform');
  }
}
